var map = {
	"./CartDetails": 5702,
	"./CartDetails.js": 5702,
	"./Contact": 8882,
	"./Contact.js": 8882,
	"./Home": 3655,
	"./Home.js": 3655,
	"./ItemMenue": 9733,
	"./ItemMenue.js": 9733,
	"./ItemMenue_old": 7703,
	"./ItemMenue_old.js": 7703,
	"./NavBar": 466,
	"./NavBar.js": 466,
	"./NavBarContact": 8132,
	"./NavBarContact.js": 8132,
	"./NavBarHome": 5861,
	"./NavBarHome.js": 5861,
	"./Restaurant": 9723,
	"./Restaurant.js": 9723,
	"./RestaurantMenu": 448,
	"./RestaurantMenu.js": 448,
	"./Restaurant_OLD": 1285,
	"./Restaurant_OLD.js": 1285,
	"./Tastes": 8664,
	"./Tastes.js": 8664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6900;